import type { DocumentData, QueryConstraint } from "firebase/firestore";
import { firestoreApi } from "../../../core/apis/firestoreApi";
import BaseApi from "../../../core/BaseApi";
import {
  type BusinessCustomerMailData,
  BusinessCustomerMailModel,
} from "./BusinessCustomerMailModel";

export default class BusinessCustomerMailsApi extends BaseApi<
  BusinessCustomerMailModel,
  BusinessCustomerMailData
> {
  /* PRIVATE APIS */

  async getAllMails() {
    if (!this.stores.sessionStore.superUser.data.isDev) {
      throw new Error("Not authed");
    }

    const qs: QueryConstraint[] = [];

    const querySnapshots = await firestoreApi.queryDocuments(this.db, ...qs);

    const models: BusinessCustomerMailModel[] = [];

    querySnapshots.forEach((querySnapshot) => {
      models.push(this.fromFirestore(querySnapshot));
    });
    this.store.load(models);
  }

  /* NEEDED BASE API OVERRIDES */

  get db() {
    return `${this.dbPrefix}business_customer_mails`;
  }

  get store() {
    return this.stores.businessCustomerMailsStore;
  }

  fromFirestore(res: DocumentData): BusinessCustomerMailModel {
    return new BusinessCustomerMailModel(this.stores, this.api, {
      uid: res.id,
      ...res.data(),
    });
  }
}
